import { useBudgetYears } from '../Budgets/budgetQueries'
import BudgetCalculator from './BudgetCalculator'

const BudgetCalculatorWrapper = () => {
  const budgetYearsQuery = useBudgetYears()
  const budgets = (budgetYearsQuery.data ?? []).map(year => ({ label: year.toString(), key: year.toString() }))

  return <BudgetCalculator budgets={budgets} />
}

export default BudgetCalculatorWrapper
